import { FONT_WEIGHT } from '@app/styles/themes/constants';
import { Avatar, Card } from 'antd';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
  border-radius: 12px;
  overflow: hidden;
  padding: 0;
  .ant-card-body {
    padding: 0;
  }
`;

export const BackgroundWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 350px;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 24px;

  &:before {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 6px;
  }

  @media screen and (max-width: 768px) {
    height: 500px;
    padding: 28px 20px;

    &:before {
      background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.65) 100%);
    }
  }
`;

export const ContentWrapper = styled.div`
  position: absolute;
  inset-block: 40px;
  inset-inline-start: 20px;
  color: #fff;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-between;

  @media screen and (max-width: 768px) {
    inset-block: 28px;
    inset-inline: 20px;
    align-items: flex-start;
    width: calc(100% - 40px);
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 768px) {
    align-items: flex-start;
    text-align: right;
  }
`;

export const TitleText = styled.h2`
  color: #fff;
  font-size: 56px;
  font-weight: ${FONT_WEIGHT.extremeBold};
  margin: 0;
  line-height: normal;
`;
export const TitleDescription = styled.p`
  font-weight: ${FONT_WEIGHT.light};
  color: #fff;
  font-size: 24px;
  margin: 0;
  line-height: normal;

  &.mt-2 {
    margin-top: 4px;
  }
`;

export const AvatarWrapper = styled.div`
  display: flex;
  align-items: flex-end;

  .title-section {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;

    .title-section {
      align-items: flex-start;
      text-align: right;
      gap: 6px;
    }
  }
`;

export const StyledAvatar = styled(Avatar)`
  border: 2px solid #fff;
  margin-left: 12px;

  @media screen and (max-width: 768px) {
    width: 84px !important;
    min-width: 84px !important;
    height: 84px !important;
    margin-left: 0;
  }
`;

export const AgentName = styled.div`
  color: #fff;
  font-size: 24px;
  font-weight: ${FONT_WEIGHT.extremeBold};
  line-height: normal;
  margin: 0;
`;
export const AgentDescription = styled.p`
  color: #fff;
  font-size: 18px;
  font-weight: ${FONT_WEIGHT.light};
  line-height: normal;
  margin: 0;
`;
